import * as Immutable from 'immutable';
import DesignLabLayerStore from './DesignLabLayerStore';
import PatternDesignServiceStore from '../../../DesignLab/_stores/PatternDesignServiceStore';
import ModelViewerStore from '../../../ModelViewer/_stores/ModelViewerStore';
import { GuideStore } from './GuideStore';

export type DesignLabState = 'lab'|'product-selector';

export interface IDesignLabStore {
	layers: Immutable.OrderedMap<string, DesignLabLayerStore>,
    state: DesignLabState
    selectedLayer: string | null
    activeScene: string | null
    activeDesignId: number | null
    activeProductId: number | null
    activeVariant: string
    activeSubproduct: string | null
    activeOptions: Immutable.OrderedMap<string, string>
    zoomScale: number,
    zoomOffsetX: number,
    zoomOffsetY: number,
    isPanning: boolean,
    isUnsaved: boolean,
    mirrorModes: Immutable.OrderedMap<string, number>,
    autoDesignSubproducts: Immutable.OrderedMap<string, boolean>,
    backgroundColor: string | null,
    patternDesignService: PatternDesignServiceStore,
    textureUpdate: number,
    warnings: Immutable.Record<{
        resolution: Immutable.OrderedMap<string, boolean>
        templates_covered: Immutable.OrderedMap<string, boolean>
    }>
    guides: Immutable.OrderedSet<GuideStore>
    designName: string,
    modelViewer: ModelViewerStore
}

const defaultDesignLabStore = Immutable.Record<IDesignLabStore>({
	layers: Immutable.OrderedMap<string, DesignLabLayerStore>(),
    state: 'lab',
    selectedLayer: null,
    activeScene: null,
    activeDesignId: null,
    activeProductId: null,
    activeVariant: 'default',
    activeSubproduct: null,
    activeOptions: Immutable.OrderedMap<string, string>(),
    zoomScale: 1,
    zoomOffsetX: 0,
    zoomOffsetY: 0,
    isPanning: false,
    isUnsaved: false,
    mirrorModes: Immutable.OrderedMap<string, number>(),
    autoDesignSubproducts: Immutable.OrderedMap<string, boolean>(),
    backgroundColor: null,
    patternDesignService: new PatternDesignServiceStore,
    textureUpdate: Date.now(),
    warnings: Immutable.Record<{
        resolution: Immutable.OrderedMap<string, boolean>
        templates_covered: Immutable.OrderedMap<string, boolean>
    }>({
        resolution: Immutable.OrderedMap<string, boolean>(),
        templates_covered: Immutable.OrderedMap<string, boolean>(),
    })(),
    guides: Immutable.OrderedSet<GuideStore>(),
    designName: '',
    modelViewer: new ModelViewerStore,
});

export default class DesignLabStore extends defaultDesignLabStore implements IDesignLabStore {}
